// CPA-3558: read-only view of a form for users who may view an entity but not edit it.
// A form (ui-form-entity, offer-partner-item, ...) provides `formReadonly`; shared inputs inject it
// and render label + value as text (ui-readonly-field) instead of the editable control.
// The nearest provider wins, so a nested block can be stricter (OP inside the partner form)
// or opt out (filters inside a read-only form provide `false`).

export function provideFormReadonly(getter) {
  return {
    formReadonly: Object.defineProperty({}, 'value', { get: getter, enumerable: true }),
  }
}

export default {
  inject: {
    formReadonly: { default: () => ({ value: false }) },
  },
  computed: {
    isFormReadonly() {
      return !!this.formReadonly.value
    },
  },
}
